/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CodeTableRowList_list$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CodeTableEditor_list$ref: FragmentReference;
declare export opaque type CodeTableEditor_list$fragmentType: CodeTableEditor_list$ref;
export type CodeTableEditor_list = $ReadOnlyArray<{|
  +ordinal: number,
  +$fragmentRefs: CodeTableRowList_list$ref,
  +$refType: CodeTableEditor_list$ref,
|}>;
export type CodeTableEditor_list$data = CodeTableEditor_list;
export type CodeTableEditor_list$key = $ReadOnlyArray<{
  +$data?: CodeTableEditor_list$data,
  +$fragmentRefs: CodeTableEditor_list$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CodeTableEditor_list",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CodeTableRowList_list"
    }
  ],
  "type": "CodeTable",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '93e44e6add04f375b61ea420aa3ef15f';

module.exports = node;
